import axios from 'axios';

const trace = (login, message, messageDetail, context = 'Mortgage SignIn Frontend') => {
  const data = { login, message, messageDetail, context };
  return axios({ method: 'post', url: '/banking/api/v1/traces', headers: getHeader(), data });
};

const getHeader = () => {
  return { 'Content-Type': 'application/json' };
};

export { trace };
